'use strict';

function AddTaskController(
  $scope,
  $mdDialog,
  EmployeesService,
  // suggestedEmployee: any,
  operation: any
) {
  $scope.employees = [];
  $scope.operation = operation;

  $scope.save = function() {
    $mdDialog.hide({
      employees: $scope.employees,
      date: $scope.date,
      description: $scope.description,
      operation
    });
  };

  $scope.queryEmployeeSearch = async function(text: string) {
    const res = await EmployeesService.find({
      filter: {
        where: {
          name: {
            ilike: `%${text}%`
          }
        }
      }
    });

    if (text.match(/(tod|todo)/i)) {
      res.unshift({
        name: 'Todos',
        id: -1
      });
    }

    return res;
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };

  $scope.addEmployee = (employee) => {
    $scope.employees.push(employee);
  };
}
AddTaskController.$inject = [
  '$scope',
  '$mdDialog',
  'EmployeesService',
  // 'suggestedEmployee',
  'operation'
];

export default AddTaskController;
